// LIDKeysDialog.js
import { useState, useEffect } from "react"
import { Button, Typography } from '@mui/material'
import DialogWrapper from "../SwmmReact_Staging/DialogWrapper"
import LIDUsageDialog from './LIDUsageDialog'
import { SwmmOut } from '@fileops/swmm-node'
import '../../css/DemoCode.css'
import '../../css/objectmodal.css'

/**
 * @param {JSON} model A state-controlled SWMM model in JSON format.
 * @param {function} setModel state-controlled update function for updating 'model'.
 * @returns UI for interactive swmm modeling.
 */
export default function LIDKeysDialog({model, setModel, keysSection, handleClose, subkeysSection='', position, setPosition, handleZIndexAssign}) {
  const [submodel, setSubmodel] = useState({ [keysSection]: model[keysSection] })
  const [LIDDialogPosition, setLIDDialogPosition] = useState({x: 100, y: 100, height: 600, width: 320})
  const [keys, setKeys]         = useState(model[keysSection][subkeysSection]?Object.keys(model[keysSection][subkeysSection]):[])
  const [selectedKey, setSelectedKey] = useState('')
  const [open, setOpen] = useState(false)

  // Determine if SI or US units
  let flowUnits = SwmmOut.FLOW_UNIT_VALUES.indexOf(model.OPTIONS.FLOW_UNITS)
  let areaFactor = 0
  if ( flowUnits <= SwmmOut.FLOW_UNIT_VALUES.indexOf("MGD")){
    areaFactor = 43560 // US Units
  }
  else {
    areaFactor = 10000 // SI Units
  }

  useEffect(()=>{
    if(subkeysSection === ''){
      setKeys(Object.keys(model[keysSection]))
  
      setSubmodel({
        [keysSection]: JSON.parse(JSON.stringify(model[keysSection]))
      })
    } else {
      model[keysSection][subkeysSection]?setKeys(Object.keys(model[keysSection][subkeysSection])):setKeys([])
  
      setSubmodel({
        [keysSection]: {
          ...model[keysSection],
          [subkeysSection]: model[keysSection][subkeysSection]?model[keysSection][subkeysSection]:[]
        }
      })
    }
  },[model])

  function showModal(isopen, layername, t1){
    async function stateChange() {
        //setOpen(isopen)
    }
      setSelectedKey(t1)
      stateChange().then(()=>{
      setOpen(true)
    })
  }

  const handleCloseMain = () => {
    setOpen(false)
  }

// This does not create new objects with new names, it adds current LID controls to it's own
// array and then applies specialized settings to them
  function createNewObject(){
    // Only create new objects if a LID has been defined for the project.
    if(Object.keys(model?.LID_CONTROLS).length === 0) return;

    // Create a new blank item in LID_USAGE
    let newLID = {
      Area: 0,
      DrainTo: '*',
      FromImp: 0,
      FromPerv: 0,
      InitSat: 0,
      Name: '',
      Number: 1,
      RptFile: '*',
      ToPerv: 0,
      Width: 0
    }

    setSubmodel(prev=>({
      ...prev, 
      LID_USAGE: {
        ...prev.LID_USAGE, 
        [subkeysSection] : [
          ...prev.LID_USAGE[subkeysSection],
          newLID
        ]
      }
    }))
    setOpen(false)
    showModal(true, keysSection, Object.keys(submodel.LID_USAGE[subkeysSection]).length)
  }

  function deleteObject(id){
    setOpen(false)

    const SECTION = model[keysSection][subkeysSection]
    SECTION.splice(id, 1)
    setSubmodel(prev=>({
      ...prev, 
      LID_USAGE: {
        ...prev.LID_USAGE, 
        [subkeysSection] : [
          ...SECTION
        ]
      }
    }))
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  return(
    <>
      {
        <DialogWrapper handleClose={handleClose} handleZIndexAssign={handleZIndexAssign} position={position} setPosition={setPosition} >
          <div style={{flexGrow: '0'}}>
            <Typography id="modal-modal-title" variant="p4" >
              <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
                <label>{keysSection}: {subkeysSection}</label>
              </div>
            </Typography>
            <Button className="hover-button" style={{minWidth:0}} onClick={()=>createNewObject()}><span className="tooltip-text" id="top">{`Add new LID`}</span>+</Button>
            
            <Button className="hover-button" style={{minWidth:0}} onClick={()=>deleteObject(selectedKey)}><span className="tooltip-text" id="top">{`Delete selected LID`}</span>-</Button>
          </div>
          <div style={{ flex:1, maxHeight: '30px', background:'black', marginLeft: '10px'}}>
            <div style={{width: '19%', display: 'inline-flex', fontSize: 12}}>Name</div>
            <div style={{width: '19%', display: 'inline-flex', fontSize: 12}}>% of Area</div>
            <div style={{width: '19%', display: 'inline-flex', fontSize: 12}}>% Imperv</div>
            <div style={{width: '19%', display: 'inline-flex', fontSize: 12}}>% Perv</div>
            <div style={{width: '19%', display: 'inline-flex', fontSize: 12}}>Rpt File</div>
          </div>
          
          <div style={{ flex:1, height:'calc(100% - 50px)', maxHeight: '800px', background:'black', overflowY: 'scroll'}}>
            {(keys.map(key => (
              model.LID_USAGE[subkeysSection][key] &&
              <Button fullWidth key={key} style={{background:key===selectedKey?'grey':'black', textTransform: 'none', justifyContent: "flex-start"}} onClick={()=>{setOpen(false); showModal(!open, keysSection, key)}}>
                <input  type = "string"
                        readOnly = {true}
                        style={{width: '20%', display: 'flex'}}
                        value={model.LID_USAGE[subkeysSection][key].Name}
                />
                <input  type = "string"
                        readOnly = {true}
                        style={{width: '20%', display: 'flex'}}
                        value={100 * model.LID_USAGE[subkeysSection][key].Number 
                          * model.LID_USAGE[subkeysSection][key].Area
                          / (model.SUBCATCHMENTS[subkeysSection].Area * areaFactor)}
                />
                <input  type = "string"
                        readOnly = {true}
                        style={{width: '20%', display: 'flex'}}
                        value={model.LID_USAGE[subkeysSection][key].FromImp}
                />
                <input  type = "string"
                        readOnly = {true}
                        style={{width: '20%', display: 'flex'}}
                        value={model.LID_USAGE[subkeysSection][key].ToPerv}
                />
                <input  type = "string"
                        readOnly = {true}
                        style={{width: '20%', display: 'flex'}}
                        value={model.LID_USAGE[subkeysSection][key].RptFile}
                />
                </Button>
            )))}
          </div>
        </DialogWrapper >
      }
      {
        open &&
          <DialogWrapper handleClose={handleCloseMain} handleZIndexAssign={handleZIndexAssign} position={LIDDialogPosition} setPosition={setLIDDialogPosition} >
            <LIDUsageDialog model={submodel} setModel={setSubmodel} targetType={'LID_CONTROLS'} fullModel={model} setFullModel={setModel} target={selectedKey} subcatchment={subkeysSection} />
          </DialogWrapper>
      }
    </>
  )
} 